import { StringColumn } from '../types/grid';
import { ColumnOptionsBase, ServerSideColumnOption } from '../types/column-options';
import { EntityColumnRef, GridRef, GroupColumnRef } from '../types/refs';

export interface StringColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, string> {
  rowGroup?: boolean;
  aggFunc?: string;
}
export type ServerSideStringColumnOptions<TRow extends object> = StringColumnOptions<TRow> & ServerSideColumnOption;

export function stringColumn<TRow extends object>(ref: GridRef<TRow> | GroupColumnRef<TRow> | EntityColumnRef<TRow>,
                                                  options: StringColumnOptions<TRow> | ServerSideStringColumnOptions<TRow>): StringColumn<TRow> {
  const column: StringColumn<TRow> = {
    ...options,
    type: 'string'
  }
  ref.createColumn(column);
  return column;
}
